import { apiPost } from "../client";
import { useMutation } from "@tanstack/react-query";
import type { IExamProgress } from "./types";

export async function apiStartExamProgress(id: string) {
  return apiPost<IExamProgress>(`/exam_progress/${id}/start`);
}

export function useMutationStartExamProgress() {
  return useMutation({
    mutationFn: (id: string) => apiStartExamProgress(id),
  });
}
